import { ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards, Req } from '@nestjs/common';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { RawMaterialGrnService } from './raw-material-grn.service';
import { GrnDTO } from './dto/raw-material-grn.dto';

import { AllGrnResponseModel, GrnResponseModel, LotCodesResponseModel, PlantRequest, RmGrnResponseModel, RMVehicleInfoResponse } from '@gtpl/shared-models/raw-material-procurement';
import { GrnRequest } from './dto/raw-material-grn.request';
import { LotCodesRequest } from './dto/lot-codes.request';
import { ReceivedBoxes } from './dto/received-boxes.request';
import { CommonResponse, PlantIdRequest } from '@gtpl/shared-models/masters';
import { SaleOrderDropDownResponseModel } from '@gtpl/shared-models/sale-management';
import { RmGrnDetailsDto } from './dto/rm-grn-details.dto';
import { RmGrnPlantRequest } from './dto/rm-grn-plants-request';
import { RMGrnItemIdReq } from './dto/grn-item-id.request';
import { LotNumberRequest } from './dto/lot-number.request';
import { GrnAbstractRequest } from './dto/grn-abstract.request';
import { PlantsIdRequest } from './dto/plants-id.request';
import { RmActualCountDto } from './dto/rm-actual-count.dto';
import { ErrorResponse, UnitRequest } from '@gtpl/shared-models/common-models';

@ApiTags('rm-grn')
@Controller('rm-grn')
export class RawMaterialGrnController {
  constructor(
    private grnService: RawMaterialGrnService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }
  @Post('/createGrn')
  async createGrn(@Body() grnDto: RmGrnDetailsDto, isUpdate: boolean = false): Promise<RmGrnResponseModel> {
    try {
      return await this.grnService.createGrn(grnDto, false);
    } catch (error) {
      console.log(error)
      return this.applicationExceptionHandler.returnException(RmGrnResponseModel, error);
    }
  }
 
  @Post('/updateGrn')
  async updateGrn(@Body() grnDto: RmGrnDetailsDto, @Req() request?: Request): Promise<RmGrnResponseModel> {
    try {
      console.log('update Grn');
      // console.log(request);
      return await this.grnService.createGrn(grnDto, true);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RmGrnResponseModel, error);
    }
  }
  @Post('/getAllGrn')
  // @UseGuards(AuthGuard('jwt'))
  async getAllGrn(@Body() req:UnitRequest): Promise<CommonResponse> {
    try {
      console.log(req,'ooooo')
      return await this.grnService.getAllGrnData(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }

  
  @Post('/getAllActiveGrn')
  async getAllActiveGrn(@Req() request: Request): Promise<AllGrnResponseModel> {
    try {
      return await this.grnService.getAllActiveGrn();
    } catch (error) {
      return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error)
    }
  }
  @Post('/activateOrDeactivateGrn')
  async activateOrDeactivateGrn(@Body() grnreq: GrnRequest): Promise<GrnResponseModel> {
    try {
      return await this.grnService.activateOrDeactivateGrn(grnreq);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(GrnResponseModel, err);
    }
  }
  // @Post('/getGrnById')
  // async getGrnById(@Body() grnreq: GrnRequest): Promise<GrnResponseModel> {
  //   try {
  //     return await this.grnService.getActiveGrnById(grnreq);
  //   } catch (err) {
  //     return this.applicationExceptionHandler.returnException(GrnResponseModel, err);
  //   }
  // }
  @Post('/getLotCodesBySoIdAndSoItemId')
  async getLotCodesBySoIdAndSoItemId(@Body() lotCodesRequest: LotCodesRequest): Promise<LotCodesResponseModel> {
    try {
      return await this.grnService.getLotCodesBySoIdAndSoItemId(lotCodesRequest);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(LotCodesResponseModel, err);
    }
  }

  @Post('/getSaleOrdersHavingLotCodes')
  async getSaleOrdersHavingLotCodes(@Body() plant: PlantsIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.grnService.getSaleOrdersHavingLotCodes(plant.plantId);
    } catch (err) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, err);
    }
  }

  @Post('/assignToRM')
  async assignToRM(@Body() grnDto: any, isUpdate: boolean = false): Promise<CommonResponse> {
    try {
      return await this.grnService.assignToRM(grnDto, false);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  // @Post('/updateReceivedBoxes')
  // async updateReceivedBoxes(@Body() receivedBoxes: ReceivedBoxes): Promise<GrnResponseModel> {
  //   try {
  //     return await this.grnService.updateReceivedBoxes(receivedBoxes);
  //   } catch (error) {
  //     return this.applicationExceptionHandler.returnException(GrnResponseModel, error);
  //   }
  // }
  @Post('/getAllLotCodes')
  async getAllLotCodes(@Body() plant: PlantIdRequest): Promise<LotCodesResponseModel> {
    try {
      return await this.grnService.getAllLotCodes(plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(LotCodesResponseModel, error);
    }
  }

  @Post('/getAllSaleOrders')
  async getAllSaleOrders(@Body() plant: PlantIdRequest): Promise<SaleOrderDropDownResponseModel> {
    try {
      return await this.grnService.getAllSaleOrders(plant);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(SaleOrderDropDownResponseModel, error);
    }
  }

  @Post('/getRmVehicleGrnById')
  async getRmVehicleGrnById(@Body() grnreq: GrnRequest): Promise<RMVehicleInfoResponse> {
    try {
      return await this.grnService.getRmVehicleGrnById(grnreq);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RMVehicleInfoResponse, error);
    }
  }

  @Post('/getRmGrnDataById')
  async getGrnDataById(@Body() grnRequest:GrnRequest): Promise<CommonResponse>  {
      try {
          return await this.grnService.getRmGrnDataById(grnRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }
  @Post('/updatePlantOrSubPlant')
  async updatePlantOrSubPlant(@Body() grnRequest:RmGrnPlantRequest): Promise<CommonResponse>  {
      try {
          return await this.grnService.updatePlantOrSubPlant(grnRequest);
      } catch (error) {
          return this.applicationExceptionHandler.returnException(CommonResponse, error);
      }
  }

  @Post('/getGrnInfoByItemId')
  async getGrnInfoByItemId(@Body() req:RMGrnItemIdReq): Promise<RMVehicleInfoResponse> {
    try {
      return await this.grnService.getGrnInfoByItemId(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(RMVehicleInfoResponse, error);
    }
  }
  
  @Post('/getTraceabilityCodeForLot')
  async getTraceabilityCodeForLot(@Body() req: LotNumberRequest): Promise<CommonResponse> {
    try {
      return await this.grnService.getTraceabilityCodeForLot(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
  @Post('/getGRNAbstract')
  async getGRNAbstract(@Body() grnAbstractRequest:GrnAbstractRequest ): Promise<AllGrnResponseModel> {
      try {             
         return await this.grnService.getGRNAbstract(grnAbstractRequest);
      } catch (error) {
         return this.applicationExceptionHandler.returnException(AllGrnResponseModel, error);
      }
  } 

  @Post('/updateGrnAuditQty')
  async updateGrnAuditQty(@Body() req:RmActualCountDto): Promise<CommonResponse> {
    try {
      return await this.grnService.updateGrnAuditQty(req);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(CommonResponse, error);
    }
  }
}



